import React, { useEffect, useState } from 'react';
import FormComponent from '../../generic-components/formComponent/FormComponent';
import { useForm } from 'react-hook-form';
import ClayLayout from '@clayui/layout';
import { useDropDownMutation } from '../../apis/useDropDownMutation';
import {
    businessProfileDetails,
    dubaiMarketDetails,
    getBasicBusinessDetails,
    personalAndContactDetails1
} from '../../config';
import CutButton from '../../generic-components/customCutButton/CutButton';
import { ClayCheckbox } from '@clayui/form';
import '../Profile/Profile.css';
import ComponentHeader from '../../generic-components/ComponentHeader/ComponentHeader';
import { useApiAuthMutationDynamic, useApiMutation } from '../../apis/useApi';
import { toast } from 'react-toastify';
import { handleUpload } from '../../utils/FileToBase64';
import ClayLoadingIndicator from '@clayui/loading-indicator';
import { useNavigate, useParams } from 'react-router-dom';
import { submitWorkflowTask } from '../../apis/apiClient';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';

const CreateRequest = () => {
    const {
        control: controlBasic,
        register: registerBasic,
        watch: watchBasic,
        handleSubmit: handleSubmitBasic,
        setError: setErrorBasic,
        setValue: setValueBasic,
        getValues,
        formState: { errors: errorsBasic }
    } = useForm({ mode: 'all' });

    const [dropdownOptions, setDropdownOptions] = useState<any>({});
    const [invitedUsers, setInvitedUsers] = useState<any>([]);
    const [checked, setChecked] = useState(false);
    const [isRevisionCommentBlock, setRevisionCommentBlock] = useState(true);
    const [isBasicInfoExpand, setIsBasicInfoExpand] = useState(true);
    const [isBusinessInfoExpand, setIsBusinessInfoExpand] = useState(true);
    const [matchMakingData, setMatchMakingData] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

     const requestorData = useSelector(
         (state: RootState) => state.requestorsSlice.requestorDetails
     );

    const { matchMakingId } = useParams();

    const uaeOfficeReference = watchBasic('uaeOfficeReference');
    const registeredCompanyEmiratesReference = watchBasic(
        'registeredCompanyEmiratesReference'
    );
    const dubaiChamberMemberReference = watchBasic(
        'dubaiChamberMemberReference'
    );

    const getBIDProgram = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_PROGRAM_REFERENCE`
    );
    const getUAENationalConfirmation = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_UAE_NATIONAL_CONFIRMATION`
    );
    const getCountryList = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_COUNTRY`
    );
    const getTechBusinessIndustry = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_TECH_BUSINESS_INDUSTRY`
    );
    const getIndustryVertical = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_INDUSTRY_VERTICAL`
    );
    const getNumberOfEmployees = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_NUMBER_OF_EMPLOYEES`
    );
    const getAnnualRevenue = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_ANNUAL_REVENUE`
    );
    const getCurrentBusinessValuation = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_CURRENT_BUSINESS_VALUATION`
    );
    const getCompanyCurrentFundingStage = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_COMPANY_CURRENT_FUNDING_STAGE`
    );
    const getPastCollaborationAndClientSize = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_PAST_COLLAB_SIZE`
    );
    const getTodaySell = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_TODAYS_DUBAI_SELL`
    );
    const getReachedOutInPast = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_REACHED_OUT_THEM_IN_PAST`
    );
    const getCategoriesToBeConnected = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_WANTED_CATEGORIES_TO_BE_CONNECTED`
    );
    const getReadyToOpenCompany = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_HOW_REQUESTOR_READY_TO_OPEN_COMPANY`
    );
    const getBiggestChallanges = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_REQUESTOR_BIGGEST_CHALLANGES`
    );
    const getBusinessModelType = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_BUSINESS_MODEL_TYPE`
    );

    const getUAEOfficeReference = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_OFFICE_REFERENCE`
    );

    const getRegisteredCompanyEmiratesReference = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/TRAVEL_REQUEST_UAE_DESTINATION`
    );

    const getDubaiChamberMemberReference = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_CHAMBER_MEMBER_REFERENCE`
    );

    const getTechnologyReadiness = useDropDownMutation(
        `o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/BID_EXPECTED_TECH_READINESS`
    );

    const industryVertical = watchBasic('requestorIndustryVertical');
    const businessModelType = watchBasic('requestorBusinessModelType');
    const requestorCompanyCurrentFundingStage = watchBasic(
        'requestorCompanyCurrentFundingStage'
    );
    const todaysSellInDubaiOrUAE = watchBasic(
        'requestorAnswerForTodaysSellInDubaiOrUAE'
    );
    const reachedOutThemInPast = watchBasic('requestorReachedOutThemInPast');
    const categoriesToBeConnected = watchBasic(
        'requestorWantedCategoriesToBeConnected'
    );
    const areReadyToOpenCompany = watchBasic(
        'howRequestorAreReadyToOpenCompany'
    );
    const biggestChallangesInUAEStratup = watchBasic(
        'requestorBiggestChallangesInUAEStratup'
    );
    const whereYourCompanyHearAboutBIDProgram = watchBasic(
        'whereYourCompanyHearAboutBIDProgram'
    );

    const [corporatePresentations, setCorporatePresentations] = useState<
        File[]
    >([]);
    const fileHandling = {
        corporatePresentation: {
            selectedFiles: corporatePresentations,
            setSelectedFiles: setCorporatePresentations
        }
    };
    const themeDisplay = (window as any).Liferay?.ThemeDisplay;

    useEffect(() => {
        setValueBasic(
            'requestorFirstName',
            themeDisplay?.getUserName()?.split(' ')[0]
        );
        setValueBasic(
            'requestorLastName',
            themeDisplay?.getUserName()?.split(' ')[1]
        );
        setValueBasic(
            'requestorWorkEmail',
            themeDisplay?.getUserEmailAddress()
        );
        const updateDropdownOptions = async () => {
            const whereYourCompanyHearAboutBIDProgram = getBIDProgram;
            const businessOwnedOrCofoundedByUAE = getUAENationalConfirmation;
            const requestorCountryOrOrigin = getCountryList;
            const requestorTechBusinessIndustrySector = getTechBusinessIndustry;
            const requestorIndustryVertical = getIndustryVertical;
            const numberOfEmployees = getNumberOfEmployees;
            const requestorAnnualRevenue = getAnnualRevenue;
            const requestorCurrentBusinessValuation =
                getCurrentBusinessValuation;
            const requestorCompanyCurrentFundingStage =
                getCompanyCurrentFundingStage;
            const requestorOutsideHeadquarterCountires = getCountryList;
            const requestorPastCollaborationAndClientSize =
                getPastCollaborationAndClientSize;
            const requestorAnswerForTodaysSellInDubaiOrUAE = getTodaySell;
            const requestorReachedOutThemInPast = getReachedOutInPast;
            const requestorWantedCategoriesToBeConnected =
                getCategoriesToBeConnected;
            const howRequestorAreReadyToOpenCompany = getReadyToOpenCompany;
            const requestorBiggestChallangesInUAEStratup = getBiggestChallanges;
            const requestorBusinessModelType = getBusinessModelType;
            setDropdownOptions((prevData: any) => ({
                ...prevData,
                whereYourCompanyHearAboutBIDProgram,
                businessOwnedOrCofoundedByUAE,
                requestorCountryOrOrigin,
                requestorTechBusinessIndustrySector,
                requestorIndustryVertical,
                numberOfEmployees,
                requestorAnnualRevenue,
                requestorCurrentBusinessValuation,
                requestorCompanyCurrentFundingStage,
                requestorOutsideHeadquarterCountires,
                requestorPastCollaborationAndClientSize,
                requestorAnswerForTodaysSellInDubaiOrUAE,
                requestorReachedOutThemInPast,
                requestorWantedCategoriesToBeConnected,
                howRequestorAreReadyToOpenCompany,
                requestorBiggestChallangesInUAEStratup,
                requestorBusinessModelType,
                uaeOfficeReference: getUAEOfficeReference,
                registeredCompanyEmiratesReference:
                    getRegisteredCompanyEmiratesReference,
                dubaiChamberMemberReference: getDubaiChamberMemberReference,
                productTechnologyReadiness: getTechnologyReadiness
            }));
        };
        updateDropdownOptions();
    }, [
        getCountryList,
        getBIDProgram,
        getUAENationalConfirmation,
        getTechBusinessIndustry,
        getIndustryVertical,
        getNumberOfEmployees,
        getAnnualRevenue,
        getCurrentBusinessValuation,
        getCompanyCurrentFundingStage,
        getPastCollaborationAndClientSize,
        getTodaySell,
        getReachedOutInPast,
        getCategoriesToBeConnected,
        getReadyToOpenCompany,
        getBiggestChallanges,
        getCountryList,
        getUAEOfficeReference,
        getRegisteredCompanyEmiratesReference,
        getDubaiChamberMemberReference,
        getTechnologyReadiness
    ]);

    const fetchMatchMakingData = useApiMutation<any, {}>(
        `/o/c/matchmakingrequestors/${matchMakingId}`,
        'get',
        {
            onSuccess: async (data) => {
                const document = data?.matchMakingToAttachment.map(
                    (item: any) => ({
                        id: item.attachment?.id,
                        documentName: item.attachment?.name ?? '',
                        href: item.attachment?.link?.href ?? '',
                        name: item.attachment?.name ?? '',
                        ...(matchMakingId && {
                            objectEntryId: item.id,
                            externalReferenceCode: item?.externalReferenceCode
                        })
                    })
                );
                setCorporatePresentations(document);
                setValueBasic('corporatePresentation', document);
                populateFormWithData(data);
                setMatchMakingData(data);
                setIsLoading(false);
            },
            onError: (error: any) => {
                console.error('Fetch error:', error);
                setIsLoading(false);
                toast.error('Failed to fetch matchmaking data', {
                    theme: 'light',
                    autoClose: 4000
                });
            }
        }
    );


    const updateEventUserMutation = useApiMutation<any, any>(
        `/o/c/matchmakingeventusers`,
        'patch'
    );

    const getEventData = useApiMutation<any, {}>(
        `/o/c/matchmakingevents/${matchMakingData?.eventId}`,
        'get',
        {
            onSuccess: (details: any) => {
                if (details) {
                    setInvitedUsers(details?.eventToEventUsers || []);
                }
            }
        }
    );

    const handleUserProfileCompletionStatus = () => {
        const email = getValues('requestorWorkEmail')?.trim();

        const user = invitedUsers.find((u: any) => u?.emailAddress === email);

        if (!user) return;

        updateEventUserMutation.mutate({
            url: `/o/c/matchmakingeventusers/${user.id}`,
            data: { userStatus: 'requestSubmitted' },
            params: {
                p_auth: (window as any)?.Liferay?.authToken
            }
        });
    };

    const extractKeys = (arr: any) => {
        return arr.map((item: any) => item.key);
    };

   const handleNullishValue = (value: any) => {
       return value == null || value === 'null' || value === 'undefined'
           ? ''
           : value;
   };

    const populateFormWithData = (data: any) => {
        setValueBasic(
            'requestorFirstName',
            handleNullishValue(data?.requestorFirstName)
        );
        setValueBasic(
            'requestorLastName',
            handleNullishValue(data?.requestorLastName)
        );
        setValueBasic(
            'requestorJobTitle',
            handleNullishValue(data?.requestorJobTitle)
        );
        setValueBasic(
            'requestorMobileNumber',
            handleNullishValue(data?.requestorMobileNumber)
        );
        setValueBasic(
            'requestorWorkEmail',
            handleNullishValue(data?.requestorWorkEmail)
        );
        setValueBasic(
            'uaeOfficeReference',
            handleNullishValue(data?.uaeOfficeReference?.key)
        );
        setValueBasic(
            'registeredCompanyEmiratesReference',
            handleNullishValue(data?.registeredCompanyEmiratesReference?.key)
        );
        setValueBasic(
            'dubaiChamberMemberReference',
            handleNullishValue(data?.dubaiChamberMemberReference?.key)
        );
        setValueBasic(
            'productTechnologyReadiness',
            handleNullishValue(data?.productTechnologyReadiness?.key)
        );
        setValueBasic(
            'membershipNumber',
            handleNullishValue(data?.membershipNumber)
        );
        setValueBasic(
            'tradeLicenseNumber',
            handleNullishValue(data?.tradeLicenseNumber)
        );

        setValueBasic(
            'whereYourCompanyHearAboutBIDProgram',
            handleNullishValue(data?.whereYourCompanyHearAboutBIDProgram?.key)
        );
        setValueBasic(
            'otherValueForBIDProgramReference',
            handleNullishValue(data?.otherValueForBIDProgramReference)
        );
        setValueBasic(
            'requestorBusinessName',
            handleNullishValue(data?.requestorBusinessName)
        );
        setValueBasic(
            'businessOwnedOrCofoundedByUAE',
            handleNullishValue(data?.businessOwnedOrCofoundedByUAE?.key)
        );
        setValueBasic(
            'requestorCountryOrOrigin',
            handleNullishValue(data?.requestorCountryOrOrigin?.key)
        );
        setValueBasic('requestorCity', handleNullishValue(data?.requestorCity));
        setValueBasic(
            'requestorBusinessIncorporationYear',
            handleNullishValue(data?.requestorBusinessIncorporationYear)
        );
        setValueBasic(
            'requestorCompanyWebsiteURL',
            handleNullishValue(data?.requestorCompanyWebsiteURL)
        );

        /**************Business Details************ */
        setValueBasic(
            'requestorTechBusinessIndustrySector',
            handleNullishValue(data?.requestorTechBusinessIndustrySector?.key)
        );
        setValueBasic(
            'requestorIndustryVertical',
            handleNullishValue(data?.requestorIndustryVertical?.key)
        );
        setValueBasic(
            'otherIndustryVertical',
            handleNullishValue(data?.otherIndustryVertical)
        );
        setValueBasic(
            'numberOfEmployees',
            handleNullishValue(data?.numberOfEmployees?.key)
        );
        setValueBasic(
            'requestorBusinessModelType',
            handleNullishValue(data?.requestorBusinessModelType?.key)
        );
        setValueBasic(
            'otherTypeOfBusinessModel',
            handleNullishValue(data?.otherTypeOfBusinessModel)
        );
        setValueBasic(
            'requestorAnnualRevenue',
            handleNullishValue(data?.requestorAnnualRevenue?.key)
        );
        setValueBasic(
            'requestorCurrentBusinessValuation',
            handleNullishValue(data?.requestorCurrentBusinessValuation?.key)
        );
        setValueBasic(
            'requestorCompanyCurrentFundingStage',
            handleNullishValue(data?.requestorCompanyCurrentFundingStage?.key)
        );
        setValueBasic(
            'requestorOutsideHeadquarterCountires',
            extractKeys(data?.requestorOutsideHeadquarterCountires)
        );
        setValueBasic(
            'requestorPastCollaborationAndClientSize',
            handleNullishValue(
                data?.requestorPastCollaborationAndClientSize?.key
            )
        );
        setValueBasic(
            'requestorClientsListKey',
            handleNullishValue(data?.requestorClientsListKey)
        );
        setValueBasic(
            'requestorAnswerForTodaysSellInDubaiOrUAE',
            handleNullishValue(
                data?.requestorAnswerForTodaysSellInDubaiOrUAE?.key
            )
        );
        setValueBasic(
            'otherAnswerForTodaySell',
            handleNullishValue(data?.otherAnswerForTodaySell)
        );
        setValueBasic(
            'introduceRequestorSpecificEntitiesInDubai',
            handleNullishValue(data?.introduceRequestorSpecificEntitiesInDubai)
        );
        setValueBasic(
            'requestorReachedOutThemInPast',
            handleNullishValue(data?.requestorReachedOutThemInPast?.key)
        );
        setValueBasic(
            'otherSpecificationForReachedOut',
            handleNullishValue(data?.otherSpecificationForReachedOut)
        );
        setValueBasic(
            'requestorWantedCategoriesToBeConnected',
            extractKeys(data?.requestorWantedCategoriesToBeConnected)
        );
        setValueBasic(
            'otherCategoriesWantedToConnectInDubai',
            handleNullishValue(data?.otherCategoriesWantedToConnectInDubai)
        );
        setValueBasic(
            'howRequestorAreReadyToOpenCompany',
            handleNullishValue(data?.howRequestorAreReadyToOpenCompany?.key)
        );
        setValueBasic(
            'otherAnswerForDubaiStartup',
            handleNullishValue(data?.otherAnswerForDubaiStartup)
        );
        setValueBasic(
            'requestorBiggestChallangesInUAEStratup',
            extractKeys(data?.requestorBiggestChallangesInUAEStratup)
        );
        setValueBasic(
            'otherAnswerForChallanges',
            handleNullishValue(data?.otherAnswerForChallanges)
        );
        setValueBasic(
            'requestorBusinessExplanation',
            handleNullishValue(data?.requestorBusinessExplanation)
        );
         setValueBasic(
             'otherCompanyCurrentFundingStage',
             handleNullishValue(data?.otherCompanyCurrentFundingStage)
         );
    };

    useEffect(() => {
        if (matchMakingId) {
            setIsLoading(true);
            fetchMatchMakingData.mutate({
                data: {},
                params: {
                    p_auth: (window as any)?.Liferay?.authToken,
                    nestedFields: 'matchMakingToAttachment',
                    restrictFields: 'actions'
                }
            });
        }
    }, [matchMakingId]);


       useEffect(() => {
           if (!matchMakingId && requestorData?.length) {
               const matchmakingRequestDetails =
                   requestorData[requestorData.length - 1];
               const document =
                   matchmakingRequestDetails?.matchMakingToAttachment.map(
                       (item: any) => ({
                           id: item.attachment?.id,
                           documentName: item.attachment?.name ?? '',
                           href: item.attachment?.link?.href ?? '',
                           name: item.attachment?.name ?? '',
                           ...(matchMakingId && {
                               objectEntryId: item.id,
                               externalReferenceCode:
                                   item?.externalReferenceCode
                           })
                       })
                   );

               setCorporatePresentations(document);
               setValueBasic('corporatePresentation', document);
               populateFormWithData(matchmakingRequestDetails);
               setMatchMakingData(matchmakingRequestDetails);
           }
       }, [requestorData?.length]);

    useEffect(() => {
        if (registeredCompanyEmiratesReference === 'dubai') {
            setValueBasic(
                'howRequestorAreReadyToOpenCompany',
                'weAlreadyHaveAnEntityInDubai'
            );
        }
    }, [registeredCompanyEmiratesReference]);

    const newPersonalAndContactDetails = personalAndContactDetails1?.filter(
        (field) => {
            if (field?.name === 'otherValueForBIDProgramReference') {
                return whereYourCompanyHearAboutBIDProgram === 'others';
            }
            return true;
        }
    );

    useEffect(() => {
        if (
            whereYourCompanyHearAboutBIDProgram &&
            whereYourCompanyHearAboutBIDProgram !== 'others'
        ) {
            setValueBasic('otherValueForBIDProgramReference', '');
        }
    }, [whereYourCompanyHearAboutBIDProgram]);

    const newBusinessProfileDetails = businessProfileDetails?.filter(
        (field) => {
            if (field?.name == 'otherIndustryVertical')
                return industryVertical == 'others';
             if (field?.name == 'otherCompanyCurrentFundingStage') {
                 return (
                     requestorCompanyCurrentFundingStage ==
                     'weHaveReceivedFundingThroughAlternativeMeansPleaseSpecify'
                 );
             } else if (field?.name == 'otherTypeOfBusinessModel')
                 return businessModelType == 'others';
            return true;
        }
    );

    const newdubaiMarketDetails = dubaiMarketDetails?.filter((field) => {
        if (field?.name == 'otherAnswerForTodaySell')
            return todaysSellInDubaiOrUAE == 'other';
        else if (field?.name == 'otherSpecificationForReachedOut')
            return reachedOutThemInPast == 'other';
        else if (field?.name == 'otherCategoriesWantedToConnectInDubai')
            return categoriesToBeConnected?.includes('others');
        else if (field?.name == 'otherAnswerForDubaiStartup')
            return areReadyToOpenCompany == 'other';
        else if (field?.name == 'otherAnswerForChallanges')
            return biggestChallangesInUAEStratup?.includes('other');
        return true;
    });

    useEffect(() => {
        if (industryVertical && industryVertical !== 'others')
            setValueBasic('otherIndustryVertical', '');
        if (businessModelType && businessModelType !== 'others')
            setValueBasic('otherTypeOfBusinessModel', '');
        if (todaysSellInDubaiOrUAE && todaysSellInDubaiOrUAE !== 'other')
            setValueBasic('otherAnswerForTodaySell', '');
        if (reachedOutThemInPast && reachedOutThemInPast !== 'other')
            setValueBasic('otherSpecificationForReachedOut', '');
        if (
            categoriesToBeConnected &&
            !categoriesToBeConnected?.includes('others')
        )
            setValueBasic('otherCategoriesWantedToConnectInDubai', '');
        if (areReadyToOpenCompany && areReadyToOpenCompany !== 'other')
            setValueBasic('otherAnswerForDubaiStartup', '');
        if (
            biggestChallangesInUAEStratup &&
            !biggestChallangesInUAEStratup?.includes('other')
        )
            setValueBasic('otherAnswerForChallanges', '');
        if (
            requestorCompanyCurrentFundingStage &&
            requestorCompanyCurrentFundingStage !==
                'weHaveReceivedFundingThroughAlternativeMeansPleaseSpecify'
        )
            setValueBasic('otherCompanyCurrentFundingStage', '');
    }, [
        industryVertical,
        businessModelType,
        todaysSellInDubaiOrUAE,
        categoriesToBeConnected,
        areReadyToOpenCompany,
        biggestChallangesInUAEStratup,
        requestorCompanyCurrentFundingStage
    ]);

      useEffect(() => {
          if (matchMakingData?.eventId && matchMakingId) {
              setValueBasic(
                  'whereYourCompanyHearAboutBIDProgram',
                  'attendedADubaiChambersEventInDubai'
              );

              getEventData.mutate({
                  data: {},
                  params: {
                      nestedFields: 'eventToEventUsers'
                  }
              });
          }
       
      }, [matchMakingData?.eventId]);

    const createMatchMakinRequestWithToken = useApiAuthMutationDynamic<any, {}>(
        `/o/c/matchmakingrequestors/scopes/BID Partner`,
        'post',
        {
            onSuccess: (data) => {
                toast.success('Request Added Successfully', {
                    theme: 'light',
                    autoClose: 2000
                });
                setIsLoading(false);
                navigate('/application');
                window.scrollTo(0, 0);
            },
            onError: (error: any) => {
                if (error?.response?.status == 400) {
                    toast.error(error?.response?.data?.title, {
                        theme: 'light',
                        autoClose: 2000
                    });
                }
                navigate('/application');
                window.scrollTo(0, 0);
                setIsLoading(false);
            }
        }
    );
    const updateMatchMakinRequestWithToken = useApiAuthMutationDynamic<any, {}>(
        `/o/c/matchmakingrequestors/${matchMakingId}`,
        'patch',
        {
            onSuccess: (data) => {
                handleUserProfileCompletionStatus();
                let transition =
                    matchMakingData?.systemStatus?.key ===
                    'qualifiedPendingInitialReview'
                        ? 'wants-approval'
                        : 'user-want-approval';

                if (
                    matchMakingData?.requestorStatus?.key ===
                    'pendingDetailsFromRequestor'
                ) {
                    transition = 'review-requestor-profile';
                }

                let payload = {
                    classPK: Number(matchMakingId),
                    transition,
                    workflowTaskId: matchMakingData?.workflowTaskId
                };

                const response = setTimeout(() => {
                    submitWorkflowTask(
                        payload,
                        '/api/v1/workflow/process-task-by-user'
                    );
                    if (response) {
                        toast.success('Request Updated Successfully', {
                            theme: 'light',
                            autoClose: 2000
                        });
                        setIsLoading(false);
                        navigate('/application');
                        window.scrollTo(0, 0);
                    }
                }, 2000);
            },
            onError: (error: any) => {
                if (error?.response?.status == 400) {
                    toast.error(error?.response?.data?.title, {
                        theme: 'light',
                        autoClose: 2000
                    });
                }
                navigate('/application');
                window.scrollTo(0, 0);
                setIsLoading(false);
            }
        }
    );

    const onSubmitBasicInfo = async (data: any) => {
        setIsLoading(true);
        const corporatePresentationFiles = corporatePresentations || [];
        let allAttachments: any[] = [];
        if (corporatePresentations?.length) {
            await handleUpload(corporatePresentationFiles, allAttachments);
        }

        const { corporatePresentation, ...payload } = data;

        const newPayload = {
            ...payload,
            requestorArrivalReference:
                matchMakingData?.requestorArrivalReference || {
                    name: 'By Site',
                    key: 'bySite'
                },
            matchmakingToAttachment: allAttachments
        };
        if (matchMakingId) {
            // data.r_partnerToMatchmakingApplication_c_corporatePartnerId=  partnerDetails?.r_partnerToServiceOffering_c_corporatePartnerId,
            newPayload.externalReferenceCode =
                matchMakingData?.externalReferenceCode;
        }

        setIsLoading(true);
        if (matchMakingId) {
            if (
                matchMakingData?.requestorStatus?.key !==
                'pendingDetailsFromRequestor'
            ) {
                newPayload.requestorStatus = 'pendingReview';
            }

            await updateMatchMakinRequestWithToken.mutateAsync({
                data: newPayload
            });
        } else {
            await createMatchMakinRequestWithToken.mutateAsync({
                data: newPayload
            });
        }
    };

    return (
        <>
            {isLoading ? (
                <ClayLoadingIndicator displayType="secondary" size="sm" />
            ) : (
                <>
                    <form onSubmit={handleSubmitBasic(onSubmitBasicInfo)}>
                        {matchMakingData?.requestorStatus?.key ===
                            'needRevisionByAccountManager' &&
                            matchMakingId && (
                                <div className="card-body customer-profile-container mb-4">
                                    <ComponentHeader
                                        title="Request for Information"
                                        setIsRequestedInfoExpand={
                                            setRevisionCommentBlock
                                        }
                                        isRequestedInfoExpand={
                                            isRevisionCommentBlock
                                        }
                                        isArrowIcon={true}
                                    />
                                    <div
                                        className={
                                            isRevisionCommentBlock
                                                ? 'expand'
                                                : 'collapse'
                                        }
                                    >
                                        <div className="ib-hr"></div>

                                        <label className="pt-0">
                                            <h1
                                                style={{
                                                    fontSize: '20px',
                                                    marginTop: '24px'
                                                }}
                                            >
                                                Requested Comment
                                            </h1>
                                            <div
                                                className="detail-content m-0"
                                                style={{
                                                    whiteSpace: 'pre-line',
                                                    wordBreak: 'break-word',
                                                    color: 'black'
                                                }}
                                            >
                                                {matchMakingData?.revisionComment ||
                                                    '-'}
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            )}

                        <div className="card-body customer-profile-container">
                            <ComponentHeader
                                title="Basic Information"
                                setIsRequestedInfoExpand={setIsBasicInfoExpand}
                                isRequestedInfoExpand={isBasicInfoExpand}
                                isArrowIcon={true}
                            />
                            <div
                                className={
                                    isBasicInfoExpand ? 'expand' : 'collapse'
                                }
                            >
                                <div className="ib-hr"></div>
                                <div className="customer-profile-title-container mt-4">
                                    <h1 className="customer-profile-title px-0 m-0">
                                        Personal and Contact details
                                    </h1>
                                </div>
                                <div className="pt-4">
                                    <ClayLayout.Row
                                        justify="start"
                                        className="content-gap"
                                    >
                                        {newPersonalAndContactDetails?.map(
                                            (data) => (
                                                <ClayLayout.Col
                                                    key={data.name}
                                                    xl={6}
                                                    lg={6}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    <FormComponent
                                                        isPartnerType={true}
                                                        placeholder={
                                                            data.placeholder
                                                        }
                                                        label={data.label}
                                                        name={data.name}
                                                        register={registerBasic}
                                                        type={data.type}
                                                        control={controlBasic}
                                                        errors={errorsBasic}
                                                        watch={watchBasic}
                                                        setError={setErrorBasic}
                                                        errorTitle={
                                                            data.errorMessage
                                                        }
                                                        options={
                                                            dropdownOptions[
                                                                data.name
                                                            ]
                                                        }
                                                        required={data.required}
                                                        component={
                                                            data.component as
                                                                | 'input'
                                                                | 'textarea'
                                                                | undefined
                                                        }
                                                        disabled={
                                                            data.name ===
                                                                'requestorFirstName' ||
                                                            data.name ===
                                                                'requestorLastName' ||
                                                            data.name ===
                                                                'requestorWorkEmail' ||
                                                            (data.name ===
                                                                'whereYourCompanyHearAboutBIDProgram' &&
                                                                matchMakingData?.eventId &&
                                                                matchMakingId)
                                                        }
                                                    />
                                                </ClayLayout.Col>
                                            )
                                        )}
                                    </ClayLayout.Row>
                                </div>
                                <div className="customer-profile-title-container">
                                    <h1 className="customer-profile-title px-0 m-0">
                                        Basic Business Details
                                    </h1>
                                </div>
                                <div className="pt-4">
                                    <ClayLayout.Row
                                        justify="start"
                                        className="content-gap"
                                    >
                                        {getBasicBusinessDetails({
                                            uaeOfficeReference,
                                            dubaiChamberMemberReference,
                                            registeredCompanyEmiratesReference
                                        }).map((data: any) => {
                                            return (
                                                <ClayLayout.Col
                                                    key={data.name}
                                                    xl={6}
                                                    lg={6}
                                                    md={6}
                                                    sm={6}
                                                    xs={12}
                                                >
                                                    <FormComponent
                                                        isPartnerType={true}
                                                        placeholder={
                                                            data.placeholder
                                                        }
                                                        label={data.label}
                                                        name={data.name}
                                                        register={registerBasic}
                                                        type={data.type}
                                                        control={controlBasic}
                                                        errors={errorsBasic}
                                                        watch={watchBasic}
                                                        setError={setErrorBasic}
                                                        errorTitle={
                                                            data.errorMessage
                                                        }
                                                        options={
                                                            dropdownOptions[
                                                                data.name
                                                            ]
                                                        }
                                                        required={data.required}
                                                        component={
                                                            data.component as
                                                                | 'input'
                                                                | 'textarea'
                                                                | undefined
                                                        }
                                                    />
                                                </ClayLayout.Col>
                                            );
                                        })}
                                    </ClayLayout.Row>
                                </div>
                            </div>
                        </div>
                        <div className="card-body customer-profile-container accordian-section mt-4">
                            <ComponentHeader
                                title="Business Details"
                                setIsRequestedInfoExpand={
                                    setIsBusinessInfoExpand
                                }
                                isRequestedInfoExpand={isBusinessInfoExpand}
                                isArrowIcon={true}
                            />
                            <div
                                className={
                                    isBusinessInfoExpand ? 'expand' : 'collapse'
                                }
                            >
                                <div className="ib-hr"></div>
                                <div className="customer-profile-title-container mt-4">
                                    <h1 className="customer-profile-title px-0 m-0">
                                        Business Profile
                                    </h1>
                                </div>
                                <div className="pt-4">
                                    <ClayLayout.Row
                                        justify="start"
                                        className="content-gap"
                                    >
                                        {newBusinessProfileDetails?.map(
                                            (data) => {
                                                const colSize =
                                                    data?.name ==
                                                    'requestorClientsListKey'
                                                        ? 12
                                                        : 6;
                                                return (
                                                    <ClayLayout.Col
                                                        key={data.name}
                                                        xl={colSize}
                                                        lg={colSize}
                                                        md={colSize}
                                                        sm={colSize}
                                                        xs={colSize}
                                                    >
                                                        <FormComponent
                                                            isPartnerType={true}
                                                            placeholder={
                                                                data.placeholder
                                                            }
                                                            label={data.label}
                                                            name={data.name}
                                                            register={
                                                                registerBasic
                                                            }
                                                            type={data.type}
                                                            control={
                                                                controlBasic
                                                            }
                                                            errors={errorsBasic}
                                                            watch={watchBasic}
                                                            setError={
                                                                setErrorBasic
                                                            }
                                                            errorTitle={
                                                                data.errorMessage
                                                            }
                                                            options={
                                                                dropdownOptions[
                                                                    data.name
                                                                ]
                                                            }
                                                            required={
                                                                data.required
                                                            }
                                                            component={
                                                                data.component as
                                                                    | 'input'
                                                                    | 'textarea'
                                                                    | undefined
                                                            }
                                                            selectedFiles={
                                                                fileHandling[
                                                                    data.name as keyof typeof fileHandling
                                                                ]?.selectedFiles
                                                            }
                                                            setSelectedFiles={
                                                                fileHandling[
                                                                    data.name as keyof typeof fileHandling
                                                                ]
                                                                    ?.setSelectedFiles
                                                            }
                                                        />
                                                    </ClayLayout.Col>
                                                );
                                            }
                                        )}
                                    </ClayLayout.Row>
                                </div>
                                <div className="customer-profile-title-container">
                                    <h1 className="customer-profile-title px-0 m-0">
                                        Dubai Market
                                    </h1>
                                </div>
                                <div className="pt-4">
                                    <ClayLayout.Row
                                        justify="start"
                                        className="content-gap"
                                    >
                                        {newdubaiMarketDetails?.map((data) => {
                                            const colSize =
                                                data?.name ==
                                                'requestorBusinessExplanation'
                                                    ? 12
                                                    : 6;
                                            return (
                                                <ClayLayout.Col
                                                    key={data.name}
                                                    xl={colSize}
                                                    lg={colSize}
                                                    md={colSize}
                                                    sm={colSize}
                                                    xs={colSize}
                                                >
                                                    <FormComponent
                                                        isPartnerType={true}
                                                        placeholder={
                                                            data.placeholder
                                                        }
                                                        label={data.label}
                                                        name={data.name}
                                                        register={registerBasic}
                                                        type={data.type}
                                                        control={controlBasic}
                                                        errors={errorsBasic}
                                                        watch={watchBasic}
                                                        setError={setErrorBasic}
                                                        errorTitle={
                                                            data.errorMessage
                                                        }
                                                        options={
                                                            dropdownOptions[
                                                                data.name
                                                            ]
                                                        }
                                                        required={data.required}
                                                        component={
                                                            data.component as
                                                                | 'input'
                                                                | 'textarea'
                                                                | undefined
                                                        }
                                                    />
                                                </ClayLayout.Col>
                                            );
                                        })}
                                    </ClayLayout.Row>
                                </div>
                                <div className="custom-checkbox-container">
                                    <ClayCheckbox
                                        checked={checked}
                                        className="custom-checkbox"
                                        style={{ fontSize: '16px' }}
                                        onChange={() => setChecked(!checked)}
                                        label="By submitting this form, you acknowledge that the information, personal data and documents provided are correct, and you consent to share them with relevant third parties to use and facilitate collaborations and partnerships for the purposes of the program."
                                    />
                                </div>
                                <ClayLayout.ContentSection className="button-group-container mt-4 mb-0 d-flex justify-content-end">
                                    <CutButton
                                        title="Save"
                                        buttonType="submit"
                                        disabled={!checked}
                                    />
                                </ClayLayout.ContentSection>
                            </div>
                        </div>
                    </form>
                </>
            )}
        </>
    );
};

export default CreateRequest;
